import React, { useEffect, useRef } from "react"
import { graphql } from "gatsby"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import { Arrow } from "../../icons"
import Slider from 'react-slick'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import parse from "html-react-parser"


const QuoteBlock = ({ items, slug }) => {
  const [dot, setDot] = React.useState(0)
  const sliderRef = React.useRef(null)
  const elementRef = useRef(null)

  useEffect(() => {
    const line = elementRef.current?.querySelectorAll('.line');

    ScrollTrigger.create({
      trigger: elementRef.current,
      start: "top bottom",
      onEnter: () => {
        line.forEach((el) => el.classList.add('is-inview'))
      },
    });

    return () => {
    };
  }, [slug]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (current, next) => {
      setDot(next)
    },
  };

  const dotClick = (index) => {
    if (sliderRef?.current) {
      sliderRef?.current?.slickGoTo(index);
    }
  }

  return (
    <section className="quote-block" ref={elementRef}>
      <div className="quote-block__inner">
        <div className="quote-block__items">
          <div className="line line--vertical center-top"></div>

          <Slider {...settings} ref={sliderRef}>
            {
              items?.map((el, i, arr) => (
                <div key={i} className="quote-block__item">
                  <div className="quote-block__content">
                    {el.quote && <h2>{parse(el.quote)}</h2>}
                    {el.name && <h3>{parse(el.name)}</h3>}
                    {el.jobtitle && <span>{parse(el.jobtitle)}</span>}
                    {el.company && <span>{parse(el.company)}</span>}
                    { arr.length > 1 &&
                      <ul className="quote-block__dots">
                        {Array.from({ length: arr.length }, (item, i) => (
                          <li key={i}>
                            <div onClick={() => dotClick(i)}
                                 className={`quote-block__dots-item ${i === dot ? "active" : ""}`}></div>
                          </li>
                        ))}
                      </ul>
                    }
                    { items?.length > 1 && <button onClick={() => sliderRef?.current?.slickNext()}><Arrow /></button> }
                  </div>

                  <div className="quote-block__image">
                    {el.image && <Asset asset={el.image} />}
                  </div>
                </div>
              ))
            }
          </Slider>
        </div>
      </div>
    </section>
  )
}

export default QuoteBlock

export const query = graphql`
fragment QuoteBlockProps on DatoCmsQuoteBlock {
  ... on DatoCmsQuoteBlock {
    id
    items {
      quote
      name
      jobtitle
      company
      link{
        ...LinkWithoutTitleProps
      }
      image {
        ...InternalAssetProps
      }
    }
  }
}
`